import InboxViewPage from './view'
export default InboxViewPage
